module.exports = __webpack_public_path__ + "assets/remove-bin.b74ec609.svg";